export const UPLOAD_DOCUMENT_STATE = {
  DISPATCH_MANIFEST: '1',
  ORDER_STER: '2',
  ORDER_COURER: '3'
};
